export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 mb-3 block">
              香香漫画
            </span>
            <p className="text-sm text-background-50/50 leading-relaxed">
              专注韩漫免费阅读的综合平台，海量韩漫全集下拉式畅读，最新韩漫及时追更，好看的韩漫免费漫画大全尽在香香漫画。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快速导航
            </h4>
            <div className="space-y-2.5">
              {[
                { label: '精选漫画', href: '#cards' },
                { label: '最近更新', href: '#updates' },
                { label: '热度排行榜', href: '#ranking' },
                { label: '分类索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              热门类型
            </h4>
            <div className="space-y-2.5">
              {['恋爱韩漫', '奇幻冒险', '穿越重生', '宫廷斗争', '悬疑惊悚', '动作热血'].map((tag) => (
                <div key={tag} className="block text-sm text-background-50/50 whitespace-nowrap">
                  {tag}
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              合作伙伴
            </h4>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-wechat-line text-background-50/60"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-weibo-line text-background-50/60"></i>
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-bilibili-line text-background-50/60"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {currentYear} 香香漫画 xiangxiang.com. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">用户协议</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-background-50/60 transition-colors whitespace-nowrap">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}